package com.flowyride.core.domain.speedcamera

import com.flowyride.core.domain.model.GeoPoint

/** A fixed automatic speed/traffic camera. */
data class SpeedCamera(
    val id: String,
    val point: GeoPoint,
    val type: SpeedCameraType,
    /** Speed limit enforced there, when published. */
    val speedLimitKmh: Int?,
)

/** Official French categories ("Type de radar"). */
enum class SpeedCameraType {
    /** ETF: classic fixed speed camera. */
    FIXED,

    /** ETT: new generation "tourelle" camera. */
    TOWER,

    /** ETD: tells cars from trucks. */
    DISCRIMINATING,

    /** ETVM: average speed over a section. */
    SECTION,

    /** ETFR: red light. */
    RED_LIGHT,

    /** ETPN: level crossing. */
    LEVEL_CROSSING,

    /** ETU: urban. */
    URBAN,

    UNKNOWN,
}

interface SpeedCameraRepository {
    /** Every fixed camera. Implementations may cache: the official list changes about once a year. */
    suspend fun all(): List<SpeedCamera>
}
